import React, { useState, useEffect, useRef } from "react";
import { IAmenitiesProps } from "./AmenitiesProps";
import { useWindowSize } from "../../../hooks/useWindowSize";
import {
  AmenityContainer,
  CenterDiv,
  AmenityColumns,
  ShowMoreLessButton,
} from "./AmenitiesHelpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

const disableIconStyle = {
  opacity: "0.5",
  cursor: "not-allowed",
};

const Amenities: React.FC<IAmenitiesProps> = (props) => {
  const winSize = useWindowSize();
  const amenityScrollRef: { [key: string]: any | undefined } = useRef();
  const totalAmenities = props.amenities ? props.amenities.length : 0;
  const [showOnLoad, setShowOnLoad] = useState(6);
  const [scrollP, setScrollP] = useState(0);
  const [scrollRightEnd, setScrollRightEnd] = useState(0);
  const [amenitiesShowCount, setAmenitiesShowCount] = useState(showOnLoad);

  const handleShowMoreLess = () => {
    const updatedCount =
      amenitiesShowCount < totalAmenities ? totalAmenities : showOnLoad;
    setAmenitiesShowCount(updatedCount);
  };

  const onAmentitesScroll = () => {
    setScrollP(amenityScrollRef.current?.scrollLeft);
    setScrollRightEnd(
      amenityScrollRef.current.scrollWidth -
        amenityScrollRef.current.clientWidth
    );
  };

  const onScrollIconClick = (right = true) => {
    const totalScrollWidth =
      amenityScrollRef.current.scrollWidth -
      amenityScrollRef.current.clientWidth;
    const scrollableInt = Math.ceil(totalScrollWidth / totalAmenities);
    if (right) {
      amenityScrollRef.current.scrollLeft += scrollableInt;
    } else {
      amenityScrollRef.current.scrollLeft -= scrollableInt;
    }
    setScrollP(amenityScrollRef.current?.scrollLeft);
  };

  useEffect(() => {
    if (winSize.width > 991) {
      setShowOnLoad(8);
    } else {
      setScrollRightEnd(
        amenityScrollRef.current?.scrollWidth -
          amenityScrollRef.current?.clientWidth
      );
      setShowOnLoad(totalAmenities);
    }
  }, [winSize]);

  useEffect(() => {
    setAmenitiesShowCount(showOnLoad);
  }, [showOnLoad]);

  return (
    <React.Fragment>
      {winSize.width < 991 ? (
        <CenterDiv>
          {totalAmenities > 3 && (
            <FontAwesomeIcon
              onClick={() => onScrollIconClick(false)}
              icon={faChevronLeft}
              style={scrollP === 0 ? disableIconStyle : {}}
            />
          )}
          <AmenityContainer
            containerRef={amenityScrollRef}
            onScroll={onAmentitesScroll}
          >
            <AmenityColumns
              amenities={props.amenities}
              color={props.color}
              amenitiesShowCount={amenitiesShowCount}
            />
          </AmenityContainer>
          {totalAmenities > 3 && (
            <FontAwesomeIcon
              onClick={() => onScrollIconClick()}
              style={scrollP >= scrollRightEnd ? disableIconStyle : {}}
              icon={faChevronRight}
            />
          )}
        </CenterDiv>
      ) : (
        <>
          <AmenityContainer>
            <AmenityColumns
              amenities={props.amenities}
              color={props.color}
              amenitiesShowCount={amenitiesShowCount}
            />
          </AmenityContainer>
          {totalAmenities > showOnLoad && (
            <ShowMoreLessButton
              onClick={handleShowMoreLess}
              color={props.color ? props.color : ""}
            >
              {amenitiesShowCount < totalAmenities
                ? "Show More Amenities +"
                : "Show Less Amenities -"}
            </ShowMoreLessButton>
          )}
        </>
      )}
    </React.Fragment>
  );
};

export default Amenities;
